import { createSelector } from 'reselect'
import { path } from 'ramda'
import { NAMESPACE } from '../constants'

const getState = (state: any) => state

export const agencySwitcherState = createSelector(getState, s => path([NAMESPACE], s))

export const isAgencySwitcherModalOpen = createSelector(agencySwitcherState, s => path(['isOpen'], s))
